export var NOT_STARTED = 1;
export var FIRST = 2;
export var FIRST_BREAK = 3;
export var SECOND = 4;
export var SECOND_BREAK = 5;
export var THIRD = 6;
export var THIRD_BREAK = 7;
export var FOURTH = 8;
export var FOURTH_BREAK = 9;
export var FIFTH = 10;
export var FIFTH_BREAK = 11;
export var SIXTH = 12;
export var SIXTH_BREAK = 13;
export var SEVENTH = 14;
export var SEVENTH_BREAK = 15;
export var EIGHTH = 16;
export var EIGHTH_BREAK = 17;
export var NINETH = 18;
export var NINETH_BREAK = 19;
export var TENTH = 20;
export var TENTH_BREAK = 21;
export var ELEVENTH = 22;
export var ELEVENTH_BREAK = 23;
export var TWELFTH = 24;
export var TWELFTH_BREAK = 25;
export var FULL_TIME = 27;
export var OVERTIME = 28;
export var OVERTIME_FINISHED = 29;
export var PENALTIES = 30;
export var FIRST_EXTRA = 31;
export var FIRST_EXTRA_BREAK = 32;
export var SECOND_EXTRA = 33;
export var SECOND_EXTRA_BREAK = 34;
export var FINISHED = 35;



// WEBPACK FOOTER //
// ./src/constants/Period.js